import {
  Comment,
  RectangleAnnotation,
  TextHighlightAnnotation,
  User,
  UserState,
} from '@readcloud/data';

export const bookmark = {
  id: '123',
  clientUpdated: new Date().toISOString(),
  clientCreated: new Date().toISOString(),
  updated: new Date().toISOString(),
  created: new Date().toISOString(),
  deleted: false,
  bookId: 'abd',
  cloudIds: [],
  location: '0',
  text: 'Test bookmark',
  version: '2',
  authorId: '456',
};

export const user = {
  id: '456',
  access_token: '',
  refresh_token: '',
  email: '',
  permissions: [],
  clientId: '',
  firstName: 'Current',
  lastName: 'User',
  role: 'Student',
  institution: '',
} as UserState;

export const knownUsers = [
  {
    id: '456',
    email: '',
    firstName: 'Current',
    lastName: 'User',
    role: 'Student',
    institutions: [],
    created: new Date().toISOString(),
    updated: new Date().toISOString(),
    deleted: false,
  },
  {
    id: '789',
    email: '',
    firstName: 'Another',
    lastName: 'User',
    role: 'Student',
    institutions: [],
    created: new Date().toISOString(),
    updated: new Date().toISOString(),
    deleted: false,
  },
] as User[];

export const currentUserComment = {
  id: '123',
  authorId: '456',
  subjectId: 'abc',
  subjectType: 'Annotation',
  text: 'This is a comment.',
  visibleInClouds: [],
  clientCreated: new Date().toISOString(),
  created: new Date().toISOString(),
  clientUpdated: new Date().toISOString(),
  updated: new Date().toISOString(),
  deleted: false,
} as Comment;

export const anotherUserComment = {
  id: '123',
  authorId: '789',
  subjectId: 'abc',
  subjectType: 'Annotation',
  text: 'This is a comment.',
  visibleInClouds: [],
  clientCreated: new Date().toISOString(),
  created: new Date().toISOString(),
  clientUpdated: new Date().toISOString(),
  updated: new Date().toISOString(),
  deleted: false,
} as Comment;

export const comments = [currentUserComment, anotherUserComment];

export const knownUsersDict = knownUsers.reduce((obj, item) => {
  return {
    ...obj,
    [item['id']]: item,
  };
}, {});

export const textAnnotation = {
  id: '123',
  type: 'Text',
  location: { pageNumber: 0 },
  data: { rects: [new DOMRect(10, 10, 10, 10)], scaleWithPage: true },
  clientCreated: new Date().toISOString(),
  created: new Date().toISOString(),
  clientUpdated: new Date().toISOString(),
  updated: new Date().toISOString(),
  deleted: false,
  visibleInClouds: [],
  visibleToUsers: [],
  author: '456',
  color: '#FFF100',
  book: 'abc',
  bookType: 'PDF',
  version: '2',
  selectedText: 'hello',
} as TextHighlightAnnotation;

export const rectAnnotation = {
  id: '123',
  type: 'Rectangle',
  location: { pageNumber: 0 },
  data: { rect: { x: 0, y: 0, height: 10, width: 10 } },
  clientCreated: new Date().toISOString(),
  created: new Date().toISOString(),
  clientUpdated: new Date().toISOString(),
  updated: new Date().toISOString(),
  deleted: false,
  visibleInClouds: [],
  visibleToUsers: [],
  author: '456',
  color: '#FFF100',
  book: 'abc',
  bookType: 'PDF',
  version: '2',
  selectedText: 'hello',
} as RectangleAnnotation;
